import { useQuery} from 'react-query';
import { fetchMetaInfo } from '../utils/meta';


export const useMetaInfo = () => {
  return useQuery('metaInfo', fetchMetaInfo, {
    staleTime: 5 * 60 * 1000,
    cacheTime: 30 * 60 * 1000,
  });
};

